<template>
  <div class="c-results__tabs">
    <div class="c-results__tablist" role="tablist" aria-label="">
      <button
        v-for="(tab, i) in tabs"
        v-bind:aria-controls="tab.panelId"
        v-bind:aria-selected="tab.selected"
        v-bind:class="tab.activeTab ? 'is-active': null"
        v-bind:key="i"
        v-bind:id="tab.tabId"
        v-bind:tabindex="tab.tabIndex"
        v-on:click="selectTab(i)"
        v-on:keyup="keyHashLookup($event.key, i)"
        ref="tab"
        class="c-results__tab"
        role="tab">
        {{tab.title}} <span>({{ tab.resultsNumber }})</span>
      </button>      
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SearchTablist",
  data() {
    return {
      activeIndex: 0,
      tabs: []
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    keyHashLookup(key, index) {
      const keyHash = {
        ArrowLeft: () => {
          const leftIndex = index - 1;
          if (leftIndex >= 0) {
            this.selectTab(leftIndex);
          }
        },
        ArrowRight: () => {
          const rightIndex = index + 1;
          if (rightIndex <= this.tabs.length - 1) {
            this.selectTab(rightIndex);
          }
        }
      };

      if (!keyHash[key]) {
        return;
      }

      return keyHash[key]();
    },
    selectTab(activeIndex) {
      this.tabs.forEach((v, i) => (v.activeTab = (i === activeIndex)));
      this.$refs.tab[activeIndex].focus();
      this.activeIndex = activeIndex;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/developers/results/SearchTablist.vue